<template>
  <page>
    <!-- {{originArea}} -->
    <transition name="modal">
      <div class="area-select" v-if="showAreaSelectPage">
        <Field
          v-model="fieldValue"
          is-link
          readonly
          placeholder="请选择所在地区"
          @click="showAreaPopup = true"
        />

        <div class="btns" v-if="fieldValue">
          <button class="btn" @click="startQA">选好了，开始答题</button>
        </div>

        <Popup v-model="showAreaPopup" round position="bottom">
          <Cascader
            v-model="cascaderValue"
            title="请选择所在地区"
            :options="areaTree"
            @close="showAreaPopup = false"
            @finish="onSelectFinish"
          />
        </Popup>
      </div>
    </transition>
    <transition name="modal">
      <questionWrap
        :time="time"
        v-if="showQuestions"
        v-on:record-result="recordResult"
        v-on:finish="onAnswerFinish"
      ></questionWrap>
    </transition>
    <transition name="">
      <div class="result-wrap" v-if="showResult">
        {{ rightNumber >= 3 ? "恭喜你" : "很遗憾" }}，<br />
        你在今天的答题打卡中获得<span>{{ rightNumber }}</span
        >分<br />
        明天请继续努力！
        <div style="margin-top: 20px">
          <button class="btn" @click="$router.push('/')">返回</button>
        </div>
      </div>
    </transition>
  </page>
</template>
<script>
import page from "@/components/page";
import questionWrap from "./question-wrap.vue";
import { getAreaTree, getAreaMap } from "./area";
import { Field, Popup, Cascader, Toast } from "vant";
import { doCheck } from "../../apis/index";
export default {
  components: { page, Field, Popup, Cascader, questionWrap },
  data() {
    return {
      showAreaSelectPage: true,
      showAreaPopup: false,
      showQuestions: false,
      showResult: false,

      rightNumber: 0,
      answerRecords: [],
      areaTree: getAreaTree(),
      areaMap: getAreaMap(),

      fieldValue: "",
      cascaderValue: "",
      originArea: undefined,

      timer:"",
      time:0,

    };
  },
  created() {},
  methods: {
    onSelectFinish({ selectedOptions }) {
      this.showAreaPopup = false;
      this.originArea = [...selectedOptions];
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    startQA() {
      this.showAreaSelectPage = false;
      setTimeout(() => {
        this.showQuestions = true;

        this.timer = setInterval(()=>{
            this.time++;
        },1000)
      }, 500);
    },
    recordResult(payload) {
      this.answerRecords.push(payload.result);
    },
    onAnswerFinish() {
      clearInterval(this.timer); 
      this.rightNumber = this.answerRecords.filter((item) => item).length;
      
      let toast = Toast({
        type: "loading",
        message: `您答对了${this.rightNumber}道题，提交中...`,
        duration: 0,
      });

      let areas = this.originArea;
      let data = {
        area: areas.map((item) => item.text),
        type: areas[areas.length - 1].type,
        extra: [
          {
            score: this.rightNumber,
            time: this.time
          },
        ],
      };
      doCheck(data).then(resp => {
        Toast({
          type: "success",
          message: resp.message,
        });
        toast.clear();
        this.showQuestions = false;
        setTimeout(() => {
          this.showResult = true;
        }, 1000);
      }).catch(()=> {
          this.$router.push('/')
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.result-wrap {
  margin-top: 50px;
  text-align: center;
  color: #fbe8a9;
  font-size: 20px;
  span {
    font-size: 28px;
  }
}
</style>